/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Issue_Codes_LockedInputs */

const en_issue_codes_locked = /** @type {(inputs: Issue_Codes_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`the SKUs already have codes made of other codes, and a SKU code never changes`)
};

/**
* | output |
* | --- |
* | "the SKUs already have codes made of other codes, and a SKU code never changes" |
*
* @param {Issue_Codes_LockedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const issue_codes_locked = /** @type {((inputs?: Issue_Codes_LockedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issue_Codes_LockedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_issue_codes_locked(inputs)
});